"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class JPromise extends Promise {
    static create(para) {
        let promise = null;
        if (typeof para == "function") {
            promise = new Promise(para);
        }
        else {
            promise = para;
        }
        let hasCanceled_ = false;
        const wrappedPromise = new Promise((resolve, reject) => {
            promise.then((val) => hasCanceled_
                ? () => {
                }
                : resolve(val), () => {
                // 不写会有警告
            });
            promise.catch((error) => hasCanceled_
                ? () => {
                }
                : reject(error));
        });
        let _promise = Object.assign({}, wrappedPromise, { terminate: () => {
                hasCanceled_ = true;
            }, then: (resolve, reject) => {
                return wrappedPromise.then(resolve, reject);
            }, otherParas: [], otherHeaders: [], useParas: (...paras) => {
                _promise.otherParas = paras;
                return _promise;
            }, useHeaders: (...headers) => {
                _promise.otherHeaders = headers;
                return _promise;
            } });
        return _promise;
    }
}
exports.default = JPromise;
